import Util from '../forecast-app/shared/util/util';
import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import {trackEvent} from '../tracking/amplitude/TrackingV2';
import {BulkCreatePersonsInput} from './__generated__/bulkCreatePersonsMutation.graphql';
import {createRangeBulkAddUpdater} from '../relay-helpers/RelayCacheHelpers';

const mutation = graphql`
	mutation bulkCreatePersonsMutation($input: BulkCreatePersonsInput!) {
		bulkCreatePersons(input: $input) {
			allPersons {
				node {
					id
					createdAt
					createdBy
					harvestUser
					economicUser
					initials
					seat
					gitlabUser {
						integrationUserId
					}
					gitlabServerUser {
						integrationUserId
					}
					githubUser {
						integrationUserId
					}
					jiraServerUser
					jiraCloudUser
					asanaUser
					adoUserId
					unit4User
					msTeamsId
					bambooHRId
					sageIntacctId
					slackId
					firstName
					lastName
					fullName
					email
					startDate
					endDate
					profilePictureId
					profilePictureDefaultId
					role {
						id
						name
					}
					skillPersons {
						skill {
							id
						}
						level {
							id
						}
					}
					profiles(first: 10000) {
						edges {
							node {
								id
								name
								seat
							}
						}
					}
					permissions
					active
					invited
					isViewer
					costPeriods(first: 10000) @connection(key: "Person_costPeriods", filters: []) {
						edges {
							node {
								id
								startDay
								startMonth
								startYear
								cost
							}
						}
					}
					department {
						id
						name
					}
					hasLoggedIn
				}
			}
			company {
				userSeats
				virtualSeats
			}
			errors
		}
	}
`;

function commit(
	environment: Environment,
	input: BulkCreatePersonsInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Employees', 'Bulk Created', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		updater: createRangeBulkAddUpdater(input.companyId || '', 'bulkCreatePersons', 'allPersons', 'Company_allPersons'),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
